import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [agentCode, setAgentCode] = useState(null);
  const [dbCode, setdbCode] = useState(null);


  useEffect(() => {
    const loggedIn = localStorage.getItem('isAuthenticated') === 'true';
    const storedAgentCode = localStorage.getItem('agentCode');
    const storedDbCode = localStorage.getItem('dbCode');

    setIsAuthenticated(loggedIn);
    setAgentCode(storedAgentCode);
    setdbCode(storedDbCode)
    setLoading(false);
  }, []);

  const login = (agentCode,userType,dbCode,uRights) => {
    sessionStorage.setItem("agentCode", agentCode);
    sessionStorage.setItem("userType", userType);
    sessionStorage.setItem("dbCode", dbCode);
     localStorage.setItem("uRights", JSON.stringify(uRights));

 
    setIsAuthenticated(true);
    setAgentCode(agentCode);
    localStorage.setItem('isAuthenticated', 'true');
    localStorage.setItem('agentCode', agentCode);
    localStorage.setItem("dbCode", dbCode);

  };

  const logout = () => {
    sessionStorage.removeItem("agentCode");
    sessionStorage.removeItem("userType");
    sessionStorage.removeItem("dbCode");


    setIsAuthenticated(false);
    setAgentCode(null);
    setdbCode(null);
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('agentCode');
    localStorage.removeItem('dbCode');
 localStorage.removeItem('uRights');
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, loading, agentCode }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
